class BrowserPreviewManager {
  /** areaId → captureId */
  private entries: Map<string, string> = new Map();
  /** areaId → MediaStream */
  private streams: Map<string, MediaStream> = new Map();
  /** areaId → canvas element (for DOM cleanup) */
  private canvases: Map<string, HTMLCanvasElement> = new Map();

  getCaptureId(areaId: string): string | undefined {
    return this.entries.get(areaId);
  }

  setCaptureId(areaId: string, captureId: string) {
    this.entries.set(areaId, captureId);
  }

  getStream(key: string): MediaStream | null {
    const stream = this.streams.get(key);
    if (stream && stream.active) return stream;
    return null;
  }

  setStream(key: string, stream: MediaStream) {
    this.streams.set(key, stream);
  }

  setCanvas(areaId: string, canvas: HTMLCanvasElement) {
    this.canvases.set(areaId, canvas);
  }

  removeStream(key: string) {
    const stream = this.streams.get(key);
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      this.streams.delete(key);
    }
  }

  destroy(areaId?: string) {
    if (areaId) {
      const stream = this.streams.get(areaId);
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        this.streams.delete(areaId);
      }
      const canvas = this.canvases.get(areaId);
      if (canvas) {
        canvas.remove();
        this.canvases.delete(areaId);
      }
      this.entries.delete(areaId);
    } else {
      this.streams.forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
      this.canvases.forEach((canvas) => canvas.remove());
      this.streams.clear();
      this.canvases.clear();
      this.entries.clear();
    }
  }
}

export default new BrowserPreviewManager();
